// extracted by mini-css-extract-plugin
export default {"about":"About_about__Qu0WA","aboutTitle":"About_aboutTitle__kRATN","aboutDescription":"About_aboutDescription__7BE3u","aboutBtn":"About_aboutBtn__7c65Z"};